import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M21 5.5a3.5 3.5 0 0 1-6.174 2.258L8 11.698l-.018-.031c.012.11.018.22.018.333l7.006 4.045a3.5 3.5 0 1 1-.938 1.768l-6.756-3.9a3 3 0 1 1-.18-4.022l6.892-3.98A3.5 3.5 0 1 1 21 5.5m-4.998 0a1.498 1.498 0 1 0 2.996 0 1.498 1.498 0 0 0-2.996 0M4.005 12a.995.995 0 1 0 1.99 0 .995.995 0 0 0-1.99 0M17.5 19.998a1.498 1.498 0 1 1 0-2.996 1.498 1.498 0 0 1 0 2.996",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }